module.exports = __webpack_public_path__ + "static/media/Invoices.5060bc2c.svg";